import React from 'react';
import { usePatientTreatmentContext } from './ContextProvider';
import PatientTreatmentPageWrapper from './PatientTreatmentPageWrapper';
import ECardWrapper from '../../../Ecard/Components/ECardWrapper/ECardWrapper';
import { ECardType } from '../../../Ecard/Enums/ECardType.enum';

interface PatientTreatmentDocumentationProps {
	type: ECardType;
	patientsOriginalId?: string;
}

const PatientTreatmentDocumentation: React.FC<
	PatientTreatmentDocumentationProps
> = ({ type, patientsOriginalId }) => {
	const { patientId } = usePatientTreatmentContext();

	return (
		<>
			<PatientTreatmentPageWrapper patientId={patientId}>
				<ECardWrapper
					type={type}
					patientId={patientId}
					patientsOriginalId={patientsOriginalId}
				/>
			</PatientTreatmentPageWrapper>
		</>
	);
};

export default PatientTreatmentDocumentation;
